type TransformRuleType =
  | "T_REPFIRST"
  | "T_REPALL"
  | "T_LCASE"
  | "T_UCASE"
  | "T_REPDATE";

const TransformRuleTypeKeys: TransformRuleType[] = [
  "T_REPALL",
  "T_REPFIRST",
  "T_UCASE",
  "T_LCASE",
  "T_REPDATE",
];

const isTransformRuleType = (value: string): value is TransformRuleType => {
  return TransformRuleTypeKeys.indexOf(value as TransformRuleType) > -1;
};

const getTransformRuleType = <T = string | TransformRuleType>(): T[] => {
  return [...TransformRuleTypeKeys] as unknown as T[];
};

const getTransformRuleTypeDisplayValue = (key: TransformRuleType): string => {
  switch (key) {
    case "T_REPALL":
      return "Replace All";
    case "T_REPFIRST":
      return "Replace First";
    case "T_LCASE":
      return "Lowercase";
    case "T_UCASE":
      return "Uppercase";
    case "T_REPDATE":
      return "Format Date";
    default:
      return key;
  }
};

export {
  TransformRuleType,
  isTransformRuleType,
  getTransformRuleType,
  getTransformRuleTypeDisplayValue,
};
